export default {
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-selectbutton {
      padding: 4px;
      background: rgba(51, 85, 104, 0.05);
      box-shadow: inset 0 1px 2px rgba(0, 33, 52, 0.05);
      border-radius: 8px;
      border: none;
    }

    .p-selectbutton .p-togglebutton {
      white-space: nowrap;
      font-weight: 500;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.55px;
      text-transform: uppercase;
      color: rgba(0, 0, 0, 0.6);
      flex: 1 1 auto;
      padding: 12px 18px;
      border: none;
    }

    .p-selectbutton .p-togglebutton:disabled {
      opacity: 0.4;
    }

    .p-selectbutton .p-togglebutton.p-togglebutton-checked {
      background: #fff;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.01),
        0 3px 1px rgba(0, 0, 0, 0.03);
      color: #158e3a;
      border-radius: 8px;
    }
  `,
};
